module.exports = __webpack_public_path__ + "img/platform_tedian.8d094182.png";